import ImageBlockIcon from "../../../images/default_image_block_new_icon.svg";
import VideoBlockIcon from "../../../images/default_video_block_new_icon.svg";
// import "./customLinkBlock.scss";

export const customImageBlock = (editor) => {
  editor.Blocks.add("Image", {
    category: "extra",
    label: "Image",

    media: `<img src="${ImageBlockIcon}" class="image-block" title="Image" alt="image" draggable="true"/>`,
    id: "Images",
    // activate: true,
    //   media: `<img src="${ImageIcon}" alt="image" draggable="false" > </img>`,
    content: {
      type: "image",
      style: {
        width: '300px',
        height: 'auto',
        'max-width': '100%',
      },
      attributes: { alt: "image" },
      unstylable: [
        "font-family",
        "font-size",
        "font-weight",
        "letter-spacing",
        "color",
        "line-height",
        "text-align",
        "text-decoration",
        "text-shadow",
        "background",
        "background-image",
        "background-repeat",
        "background-position",
        "background-size",
        "background-attachment",
        "modular_content",
      ],
    },
  });

  /*  editor.Blocks.add("Videos", {
        category: "extra",
        label: "Video",
        
        media: `<img src="${VideoBlockIcon}" class="video-block" alt="video" draggable="true"/>`,
        id: "Video",
    //   media: `<img src="${VideoIcon}" alt="video" draggable="true" /> `,
    //   activate: true,
      content: {
        type: "video",
        src: "",
        unstylable: [
          "font-family",
          "font-size",
          "font-weight",
          "letter-spacing",
          "color",
          "line-height",
          "text-align",
          "text-decoration",
          "text-shadow",
          "transform",
          "transition",
          "perspective",
          "modular_content",
        ],
        style: {
          width: "300px",
        },
      },
      }); */

  editor.DomComponents.addType("video", {
    extend: "video",
    isComponent: (el) => el.tagName === "VIDEO",

    model: {
      defaults: {
        tagName: "video",
        traits: ["src", "controls", "autoplay", "loop", "muted"],
        droppable: 0,
        draggable: true,
        stylable: ["width", "height", "background-color"],
        styles: `
          video {
            object-fit: cover;
          }
        `,
      },

      init() {
       
         this.on('change:autoplay', () => {
          const id = this.get("autoplay");
          const attrs = { ...this.get('attributes') };
          if (id) {
            attrs.autoplay = true;
            attrs.muted = true;   // required for browser autoplay
          } else {
            delete attrs.muted;
            delete attrs.autoplay;
          }
          this.set('attributes', attrs);
        }); 
      },
    },

    /* view: {
      tagName: "video",
      init() {
        // This ensures no wrapper is used
        this.el.setAttribute("controls", true);
      },
      render() {
        this.el.src = this.model.get("src") || "";
        return this;
      },
    }, */
  });

  editor.Blocks.add("Videos", {
    category: "extra",
    label: "Video",
    media: `<img src="${VideoBlockIcon}" class="video-block" alt="video" draggable="true"/>`,
    id: "Video",
    content: {
      type: "video",
      src: "",
      style: {
        width: "300px",
        'max-width': '100%',
        display: "inline-block",
        "object-fit": "cover",
        "background-color": "black"
      },
    },
  });
  //   editor.Components.addType("paragraph", {
  //     extend: "paragraph",
  //     model: {
  //       defaults: {
  //         editable: false,
  //         droppable: `[data-gjs-type="form"],
  //        [data-gjs-type="default"],
  //        [data-gjs-type="Div"],
  //        [data-gjs-type="text"],
  //        [data-gjs-type="image"],
  //        [data-gjs-type="table"],
  //        [data-gjs-type="tabs"],
  //        [data-gjs-type="textarea"],
  //        [data-gjs-type="video"],
  //        [data-gjs-type="hr"],
  //        [data-gjs-type="input"],
  //        [data-gjs-type="select"],
  //        [data-gjs-type="button"],
  //        [data-gjs-type="label"],
  //        [data-gjs-type="checkbox"],
  //        [data-gjs-type="radio"]
  //        `,

  //         style: {
  //           display: "inline-block",
  //           padding: "5px",
  //           "min-height": "50px",
  //           "min-width": "50px",
  //         },
  //         attributes: { href: "http://google.com" },
  //       },
  //     },
  //   });
};
